// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { useGetApi } from "../client";
import { useCallback } from "react";

export function useApproveMultipleAnwesenheiten(): (
  requestBody: Array<string>
) => Promise<void> {
  const getAPI = useGetApi();
  return useCallback(
    async (requestBody) =>
      (await getAPI()).anwesenheiten.approveMultipleAnwesenheiten({
        requestBody,
      }),
    [getAPI]
  );
}
